import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { CoreCounterState } from '@osos/shared/legacy-core';
import { CounterWidgetDataEntryPresenterModel } from '@osos/shared/types';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-counter-widget-item',
  templateUrl: './counter-widget-item.component.html',
  styleUrls: ['./counter-widget-item.component.scss'],
  standalone: false,
})
export class CounterWidgetItemComponent implements OnInit {
  @Input() counter: CounterWidgetDataEntryPresenterModel;
  overlayVisible = false;
  entriesCount$: Observable<number>;
  constructor(private store: Store) {}

  ngOnInit() {
    this.entriesCount$ = this.store.select(
      CoreCounterState.presentedCounterEntriesCount(this.counter.id),
    );
  }
  toggle() {
    this.overlayVisible = !this.overlayVisible;
  }
}
